import type { ValidCurrency } from '@/types/plans';

const LOCALE_BY_CURRENCY: Record<ValidCurrency, string> = {
  USD: 'en-US',
  GBP: 'en-GB',
  CAD: 'en-CA',
  EUR: 'en-IE',
  INR: 'en-IN',
  BRL: 'pt-BR',
  AUD: 'en-AU',
};

export function getLocaleForCurrency(currency: ValidCurrency): string {
  return LOCALE_BY_CURRENCY[currency];
}
